import React from 'react';
import PODLogo from "js/components-v2/common/Header/common/PODLogo";
import {Link} from "@reach/router";
import AppUser from "js/stores/AppUser";

const DesktopLeftLinks = () => {
  return (
    <div className="left-nav d-flex align-items-center">
      <PODLogo />
      <ul className="list-unstyled d-flex align-items-center">
        {!AppUser.isLoggedIn
          && (
            <>
              <li>
                <Link to={'buyer'}>Buyer</Link>
              </li>
              <li>
                <Link to={'seller'}>Seller</Link>
              </li>
              {/*<li>*/}
              {/*  <Link to={'psp'}>SPP</Link>*/}
              {/*</li>*/}
            </>
          )
        }
      </ul>
    </div>
  );
}

export default DesktopLeftLinks;
